import { useState } from "react";

// A wizard's position, held by the form using the wizard, which renders the current step itself. next and previous
// move on from the position on screen, which the form passes in: while a step is edited from the review that isn't
// the stored step.
const useWizard = () => {
  const [step, setStep] = useState(0);
  const [substep, setSubstep] = useState(0);
  const [highestStepVisited, setHighestStepVisited] = useState(0);
  const [highestSubstepVisited, setHighestSubstepVisited] = useState(0);

  const next = (steps, fromStep, fromSubstep) => {
    if (steps[fromStep]?.substeps?.length - 1 > fromSubstep) {
      setSubstep(fromSubstep + 1);
      setHighestSubstepVisited(fromSubstep + 1);
    } else {
      setStep(fromStep + 1);
      setHighestStepVisited(fromStep + 1);
      setSubstep(0);
    }
  };

  const previous = (steps, fromStep, fromSubstep) => {
    if (fromSubstep > 0) {
      setSubstep(fromSubstep - 1);
      return;
    }

    if (fromStep > 0) {
      setStep(fromStep - 1);
      setSubstep(steps[fromStep - 1]?.substeps?.length - 1);
      return;
    }
  };

  return {
    step,
    setStep,
    substep,
    setSubstep,
    highestStepVisited,
    highestSubstepVisited,
    next,
    previous,
  };
};

export default useWizard;
